import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=8c60eb3a&"
import script from "./TableCell.vue?vue&type=script&lang=js&"
export * from "./TableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports